import React from 'react';
import { IconProps } from '../types';
const MinecraftGoldenShovel: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="11" y="2" width="1" height="1" fill="rgba(130, 93, 22, 255)" />
<rect x="12" y="2" width="1" height="1" fill="rgba(130, 93, 22, 255)" />
<rect x="13" y="2" width="1" height="1" fill="rgba(63, 46, 14, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(130, 93, 22, 255)" />
<rect x="11" y="3" width="1" height="1" fill="rgba(253, 255, 118, 255)" />
<rect x="12" y="3" width="1" height="1" fill="rgba(253, 255, 118, 255)" />
<rect x="13" y="3" width="1" height="1" fill="rgba(233, 177, 21, 255)" />
<rect x="14" y="3" width="1" height="1" fill="rgba(63, 46, 14, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(130, 93, 22, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(253, 255, 118, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(234, 238, 87, 255)" />
<rect x="12" y="4" width="1" height="1" fill="rgba(233, 177, 21, 255)" />
<rect x="13" y="4" width="1" height="1" fill="rgba(253, 255, 118, 255)" />
<rect x="14" y="4" width="1" height="1" fill="rgba(63, 46, 14, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(130, 93, 22, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(253, 255, 118, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(234, 238, 87, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(233, 177, 21, 255)" />
<rect x="12" y="5" width="1" height="1" fill="rgba(234, 238, 87, 255)" />
<rect x="13" y="5" width="1" height="1" fill="rgba(253, 255, 118, 255)" />
<rect x="14" y="5" width="1" height="1" fill="rgba(63, 46, 14, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(73, 54, 21, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(233, 177, 21, 255)" />
<rect x="11" y="6" width="1" height="1" fill="rgba(234, 238, 87, 255)" />
<rect x="12" y="6" width="1" height="1" fill="rgba(253, 255, 118, 255)" />
<rect x="13" y="6" width="1" height="1" fill="rgba(63, 46, 14, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(73, 54, 21, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(137, 103, 39, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(253, 255, 118, 255)" />
<rect x="12" y="7" width="1" height="1" fill="rgba(63, 46, 14, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(73, 54, 21, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(137, 103, 39, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(63, 46, 14, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(73, 54, 21, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(104, 78, 30, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(73, 54, 21, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(137, 103, 39, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(73, 54, 21, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(104, 78, 30, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="2" y="12" width="1" height="1" fill="rgba(73, 54, 21, 255)" />
<rect x="3" y="12" width="1" height="1" fill="rgba(73, 54, 21, 255)" />
<rect x="4" y="12" width="1" height="1" fill="rgba(137, 103, 39, 255)" />
<rect x="5" y="12" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="2" y="13" width="1" height="1" fill="rgba(73, 54, 21, 255)" />
<rect x="3" y="13" width="1" height="1" fill="rgba(137, 103, 39, 255)" />
<rect x="4" y="13" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="3" y="14" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="4" y="14" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
</svg>);
export default MinecraftGoldenShovel;